import { Blocks, BookOpen, House, Plug, Settings, Workflow } from 'lucide-react';
import SidebarNavItem from '../../../../components/patterns/SidebarNavItem.jsx';
import Avatar from '../../../../components/primitives/Avatar.jsx';
import PieveWordmark from '../../../../components/surfaces/PieveWordmark.jsx';

/** Sidebar of the gallery, laid out like the app's: it shows the nav item in every state. */
const GallerySidebar = () => {
  return (
    <aside className="gallery-sidebar">
      <div className="gallery-sidebar__brand">
        <PieveWordmark height={22} />
      </div>
      <nav className="gallery-sidebar__nav" aria-label="Gallery">
        <SidebarNavItem to="/gallery" end icon={House} label="Design system" />
        <SidebarNavItem to="/gallery/automations" icon={Workflow} label="Automations" count={2} />
        <SidebarNavItem to="/gallery/connections" icon={Plug} label="Connections" />
        <SidebarNavItem to="/gallery/skills" icon={Blocks} label="Skills" />
        <SidebarNavItem to="/gallery/knowledge" icon={BookOpen} label="Knowledge" />
      </nav>
      <div className="gallery-sidebar__footer">
        <SidebarNavItem to="/gallery/settings" icon={Settings} label="Settings" />
        <div className="gallery-sidebar__account">
          <Avatar name="Ana Lucia Ortega" size="sm" />
          <div className="gallery-sidebar__account-text">
            <span className="gallery-sidebar__account-name">Ana Lucia Ortega</span>
            <span className="gallery-sidebar__account-org">Northwind Supply</span>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default GallerySidebar;
